export default "__VITE_ASSET__9c56eaf6__"